import { Box } from "@mui/material";
import React from "react";
import ResponsiveFlex from "../pages/app/provider/patient/patient-list/patient-chart-new/ResponsiveFlex";

// Simple Iframe Component (no modal functionality)
interface IframeProps {
  url: string;
  width?: string;
  height?: string;
}

export const ScriptsureIframe: React.FC<IframeProps> = ({
  url,
  width = "100%",
  height = "100%",
}) => {
  const cssUrl = `${window.location.origin}/scriptsure.css`;

  return (
    <ResponsiveFlex>
      <Box
        sx={{
          width,
          height,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          borderRadius: "8px",
          overflow: "hidden",
          boxSizing: "border-box",
          border: "1px solid rgb(24, 22, 22)",
        }}
      >
        <iframe
          // src={url}
          src={`${url}&css=${cssUrl}`}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
          }}
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-presentation"
        />
      </Box>
    </ResponsiveFlex>
  );
};
